import styled, { css } from 'styled-components';

import {
  scale005,
  xdlColorA11yBorderOnLight,
  xdlColorCardInspire01,
  xdlColorCardInspire02,
  xdlColorCardInspire03,
  xdlColorCardInspire04,
  xdlColorCardInspire05,
  xdlColorCardInspire06,
  xdlColorCardInspire07,
  xdlColorTextOnLight,
} from '@xing-com/tokens';

import { Card } from '..';

import type { CardInspireVariants } from './card-inspire.types';

type CardInspireTProps = {
  $variant: CardInspireVariants;
};

// *** Variants ***
export const variants = {
  1: css`
    background-color: ${xdlColorCardInspire01} !important;
  `,
  2: css`
    background-color: ${xdlColorCardInspire02} !important;
  `,
  3: css`
    background-color: ${xdlColorCardInspire03} !important;
  `,
  4: css`
    background-color: ${xdlColorCardInspire04} !important;
  `,
  5: css`
    background-color: ${xdlColorCardInspire05} !important;
  `,
  6: css`
    background-color: ${xdlColorCardInspire06} !important;
  `,
  7: css`
    background-color: ${xdlColorCardInspire07} !important;
  `,
};

// *** Components ***
export const CardContainer = styled.div`
  // FIXME: Move helmet styles here after upgrading to Next-Yak
`;

export const CardInspire = styled(Card)<CardInspireTProps>`
  && {
    border-color: ${xdlColorA11yBorderOnLight};
    border-width: ${scale005};
    color: ${xdlColorTextOnLight};
  }

  ${({ $variant }) => {
    switch ($variant) {
      case 1:
        return variants['1'];
      case 2:
        return variants['2'];
      case 3:
        return variants['3'];
      case 4:
        return variants['4'];
      case 5:
        return variants['5'];
      case 6:
        return variants['6'];
      case 7:
        return variants['7'];
      default:
        return $variant satisfies undefined;
    }
  }}
`;
